import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SimpleInPersonIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M11.878 8.99c-2 0-3.62-1.62-3.62-3.62s1.62-3.62 3.62-3.62 3.62 1.62 3.62 3.62-1.62 3.62-3.62 3.62zm0-5.24c-.89 0-1.62.73-1.62 1.62 0 .89.73 1.62 1.62 1.62.89 0 1.62-.73 1.62-1.62 0-.89-.73-1.62-1.62-1.62zM11.818 19c-.63 0-1.22-.29-1.6-.79l-.08-.12-2.38-4.29c-.28-.51-.43-1.09-.43-1.68v-.89c0-1.09.88-1.97 1.97-1.97h5.04c1.09 0 1.97.88 1.97 1.97v.89c0 .59-.15 1.17-.43 1.68l-2.46 4.41c-.38.5-.97.79-1.6.79zm2.49-7.77l-5.02.03.03.86c0 .25.06.49.18.71l2.31 4.17 2.31-4.17c.12-.21.18-.46.18-.71v-.89h.01z"
                        }),
                        _jsx("path", {
                            d: "M19.368 22.24H4.638c-.39 0-.75-.2-.96-.52-.21-.33-.24-.73-.08-1.09l1.18-2.96c.2-.45.61-.71 1.06-.71h1.65c.55 0 1 .45 1 1s-.45 1-1 1h-1.07l-.51 1.29h12.19l-.52-1.29h-1.08c-.55 0-1-.45-1-1s.45-1 1-1h1.65c.45 0 .86.27 1.04.68l1.23 3.03a1.147 1.147 0 01-1.06 1.58l.01-.01zm-.8-.84s.01.03.02.04l-.02-.04zm-13.1-.04l-.02.06s.02-.04.02-.06z"
                        })
                    ]
                })
            })
        ]
    });
};
SimpleInPersonIcon.isCarinaIcon = true;
export default SimpleInPersonIcon;
